(() => {
  'use strict';

  if (window.PWRecyclingDeliveryLayoutLoaded) return;
  window.PWRecyclingDeliveryLayoutLoaded = true;

  let scheduled = false;

  const getOptionContents = (root) => {
    const contents = [];
    if (!(root instanceof Document || root instanceof Element)) return contents;

    if (root instanceof Element && root.matches('.pw-buybox-options__content')) {
      contents.push(root);
    }

    root.querySelectorAll('.pw-buybox-options__content').forEach((content) => {
      if (!contents.includes(content)) contents.push(content);
    });

    return contents;
  };

  const moveRecyclingOption = (root = document) => {
    getOptionContents(root).forEach((content) => {
      const deliverySection = content.querySelector(':scope > .pw-services--delivery');
      const deliveryGrid = deliverySection?.querySelector('.pw-service-grid');
      const recyclingSection = content.querySelector(':scope > .pw-services--recycling');
      const recyclingCard = recyclingSection?.querySelector('.pw-service-card');

      if (!deliveryGrid || !recyclingSection || !recyclingCard) return;

      recyclingCard.classList.add('pw-service-card--recycling');
      deliveryGrid.append(recyclingCard);
      recyclingSection.remove();
    });
  };

  const scheduleMove = (root = document) => {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      moveRecyclingOption(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => moveRecyclingOption(document), { once: true });
  } else {
    moveRecyclingOption(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    moveRecyclingOption(event.target);
  });

  new MutationObserver((records) => {
    const relevantRecord = records.find((record) => Array.from(record.addedNodes).some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches('.pw-buybox-options__content, .pw-services--recycling')
        || Boolean(node.querySelector('.pw-buybox-options__content, .pw-services--recycling'));
    }));

    if (relevantRecord) scheduleMove(document);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
